'use strict';
angular.module('app')
.factory('validateEmail', function ()
{
    return function validateEmail(emailAddress)
    {
        //http://emailregex.com/
        var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (reg.test(emailAddress)) {
            return true;
        }

        return false;
    }
});
